import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "optionButton", "optionInput", "optionSelect", "price", "interval", "discountLabel"]
  static values = { serviceId: Number }

  connect() {
    // Stop click propagation from toggle buttons to prevent card selection
    if (this.hasToggleTarget) {
      this.toggleTarget.addEventListener("click", (e) => e.stopPropagation())
    }
    // Stop click propagation from dropdown to prevent card selection
    if (this.hasOptionSelectTarget) {
      this.optionSelectTarget.addEventListener("click", (e) => e.stopPropagation())
    }
  }

  // Handle dropdown selection (for 4+ billing options)
  selectFromDropdown(event) {
    event.stopPropagation()

    const select = event.currentTarget
    const selectedOption = select.options[select.selectedIndex]
    const optionId = selectedOption.value
    const price = parseFloat(selectedOption.dataset.price)
    const interval = selectedOption.dataset.interval
    const discountLabel = selectedOption.dataset.discountLabel || ""

    this.updateDisplay(optionId, price, interval, discountLabel)
  }

  // Handle button selection (for 2-3 billing options)
  selectOption(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const optionId = button.dataset.optionId
    const price = parseFloat(button.dataset.price)
    const interval = button.dataset.interval
    const discountLabel = button.dataset.discountLabel || ""

    // Update button states
    this.optionButtonTargets.forEach(btn => {
      btn.classList.remove("bg-white", "shadow-sm", "text-gray-900", "font-medium")
      btn.classList.add("text-gray-500")
    })
    button.classList.add("bg-white", "shadow-sm", "text-gray-900", "font-medium")
    button.classList.remove("text-gray-500")

    this.updateDisplay(optionId, price, interval, discountLabel)
  }

  // Shared method to update display and notify parent controller
  updateDisplay(optionId, price, interval, discountLabel) {
    // Update price display
    if (this.hasPriceTarget) {
      this.priceTarget.textContent = this.formatCurrency(price)
    }

    // Update interval display
    if (this.hasIntervalTarget) {
      this.intervalTarget.textContent = `/ ${interval}`
    }

    // Update discount label
    if (this.hasDiscountLabelTarget) {
      if (discountLabel) {
        this.discountLabelTarget.textContent = discountLabel
        this.discountLabelTarget.classList.remove("hidden")
      } else {
        this.discountLabelTarget.classList.add("hidden")
      }
    }

    // Update hidden input
    if (this.hasOptionInputTarget) {
      this.optionInputTarget.value = optionId
    }

    // Update the card's data-price attribute for service-selection controller
    // this.element IS the card (it has both data-controller and data-service-selection-target)
    this.element.dataset.price = price

    // Dispatch event to notify service-selection controller of price change
    this.element.dispatchEvent(new CustomEvent("priceChanged", {
      bubbles: true,
      detail: { serviceId: this.serviceIdValue, price: price }
    }))
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount)
  }
}
